import {
  Briefcase,
  Calendar,
  Users,
  TrendingUp,
  HeartPulse,
  DollarSign,
  ShoppingCart,
  Cloud,
  Building,
  Rocket,
} from "lucide-vue-next";

export const stats = [
  {
    id: "projects",
    number: 200,
    suffix: "+",
    label: "Projects Delivered",
    description: "Successfully completed projects across diverse industries",
    icon: Briefcase,
  },
  {
    id: "experience",
    number: 5,
    suffix: "+",
    label: "Years Combined Experience",
    description: "Collective expertise in digital product development",
    icon: Calendar,
  },
  {
    id: "clients",
    number: 50,
    suffix: "+",
    label: "Happy Clients",
    description: "Organizations we've partnered with to drive success",
    icon: Users,
  },
  {
    id: "retention",
    number: 95,
    suffix: "%",
    label: "Client Retention",
    description: "Clients who return for additional projects and support",
    icon: TrendingUp,
  },
];

export const industries = [
  {
    id: "healthcare",
    name: "Healthcare",
    description: "Digital health solutions and patient management systems",
    icon: HeartPulse,
  },
  {
    id: "fintech",
    name: "FinTech",
    description: "Financial technology and secure payment platforms",
    icon: DollarSign,
  },
  {
    id: "ecommerce",
    name: "E-Commerce",
    description: "Online retail platforms and marketplace solutions",
    icon: ShoppingCart,
  },
  {
    id: "saas",
    name: "SaaS",
    description: "Cloud-based software and subscription services",
    icon: Cloud,
  },
  {
    id: "enterprise",
    name: "Enterprise",
    description: "Large-scale business applications and systems",
    icon: Building,
  },
  {
    id: "startups",
    name: "Startups",
    description: "MVP development and product launches",
    icon: Rocket,
  },
];
